import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import Linkify from "react-linkify"; //Material imports

import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import Fade from "@material-ui/core/Fade"; //Limitless imports

import { withi18n } from "../../hocs/i18n";

var SystemDialogue = function SystemDialogue(_ref) {
  var t = _ref.t,
      classes = _ref.classes,
      shouldAnimate = _ref.shouldAnimate,
      dialogue = _ref.dialogue,
      dialogueClasses = _ref.dialogueClasses,
      Icon = _ref.Icon;
  var body = dialogue.body;

  var allClasses = _objectSpread({}, classes, {}, dialogueClasses);

  return /*#__PURE__*/React.createElement(Fade, {
    in: true,
    appear: shouldAnimate
  }, /*#__PURE__*/React.createElement("div", {
    className: allClasses.infoDialogueContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(allClasses.infoDialogueBody, " ").concat(allClasses.primaryBackground)
  }, Icon, /*#__PURE__*/React.createElement(Linkify, {
    properties: {
      target: "_blank",
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    className: allClasses.primaryText,
    component: "span",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: t(body)
    }
  }))), Icon)));
};

var styles = function styles() {
  return {
    infoDialogueContainer: {
      display: "flex",
      flex: "1",
      flexDirection: "column",
      paddingTop: 10,
      paddingBottom: 10
    },
    infoDialogueBody: {
      wordWrap: "break-word",
      wordBreak: "break-word",
      fontSize: 16,
      lineHeight: "1.333",
      padding: 13,
      marginLeft: "10%",
      marginRight: "10%",
      textAlign: "center",
      flexDirection: "row",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  };
};

export default withStyles(styles)(withi18n(SystemDialogue));